import { render, staticRenderFns } from "./Lgx243725849601837204.vue?vue&type=template&id=b52a53ca&scoped=true&"
import script from "./Lgx243725849601837204.vue?vue&type=script&lang=js&"
export * from "./Lgx243725849601837204.vue?vue&type=script&lang=js&"
import style0 from "./Lgx243725849601837204.vue?vue&type=style&index=0&id=b52a53ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52a53ca",
  null
  
)

export default component.exports